var _line, _path, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1054,
    height: 206,
    viewBox: "0 0 1054 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "line line2",
    x1: 250.664,
    y1: 2.99976,
    x2: 892.664,
    y2: 2.99976,
    stroke: "#0561F5",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "line line3",
    d: "M1048.67 205.25C1049.76 205.384 1050.76 204.605 1050.89 203.508L1053.09 185.643C1053.22 184.546 1052.44 183.548 1051.35 183.414C1050.25 183.279 1049.25 184.059 1049.12 185.155L1047.17 201.036L1031.29 199.086C1030.19 198.951 1029.19 199.731 1029.06 200.827C1028.92 201.924 1029.7 202.922 1030.8 203.056L1048.67 205.25ZM890.088 3.23108L1047.33 204.496L1050.49 202.033L893.24 0.768433L890.088 3.23108Z",
    fill: "#0561F5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "line",
    x1: 1.38741,
    y1: 119.236,
    x2: 251.819,
    y2: 2.45794,
    stroke: "#0561F5",
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorks);
export default __webpack_public_path__ + "static/media/works.b07b270c861cb72d91244f6f4ad23a2f.svg";
export { ForwardRef as ReactComponent };